import React from "react";

export const flattenOptions = (nodes, parentPath = []) => {
    let result = [];

    nodes.forEach((node) => {
        const currentPath = [...parentPath, node.text];

        if (node.value) {
            result.push({
                ...node,
                display: currentPath.join(" / "),
            });
        }

        if (node.children?.length) {
            result.push(...flattenOptions(node.children, currentPath));
        }
    });

    return result;
};

export const MAX_MENU_WIDTH = 240;
export const MIN_MENU_WIDTH = 180;

const measureTextWidth = (text, font) => {
    const canvas =
        measureTextWidth.canvas ||
        (measureTextWidth.canvas = document.createElement("canvas"));

    const context = canvas.getContext("2d");

    context.font = font;

    return context.measureText(text).width;
};

export const getMenuWidth = (items = []) => {
    const element = document.querySelector(".nested-field-dropdown__item");

    const font = element
        ? getComputedStyle(element).font
        : getComputedStyle(document.body).font;

    const longest = items.reduce((max, item) => {
        const width = measureTextWidth(item.text || "", font);

        return Math.max(max, width);
    }, 0);

    return Math.min(Math.max(longest + 90, MIN_MENU_WIDTH), MAX_MENU_WIDTH);
};

const FLYOUT_GROUPS = ["Phone", "Email", "Social Media"];

const isLocationGroup = (label = "") => /^Location\s+\d+$/i.test(label);

const isFlyoutGroup = (label) =>
    FLYOUT_GROUPS.includes(label) || isLocationGroup(label);

const createLeaf = (field) => ({
    key: field.flatten_path,
    value: field.flatten_path,
    text: field.label,
    field_type: field.field_type,
    type: "flat-leaf",
});

const createFlyout = (group) => ({
    key: group.label,
    text: group.label,
    type: "flyout",

    children: group.fields.map((field) => ({
        key: field.flatten_path,
        value: field.flatten_path,
        text: field.label,
        field_type: field.field_type,
    })),
});

export const formatStandardFields = (section) => {
    return {
        key: section.label,
        text: `${section.label} Standard Fields`,
        type: "header",

        children: [
            ...(section.children || []).flatMap((group) => {
                const items = [];

                items.push({
                    key: `${group.label}-header`,
                    text: group.label,
                    type: "sub-header",
                });

                if (isFlyoutGroup(group.label)) {
                    items.push(createFlyout(group));
                } else {
                    items.push({
                        key: `${group.label}-header`,
                        text: group.label,
                        type: "sub-header",
                    });

                    items.push(...group.fields.map(createLeaf));
                }

                return items;
            }),

            ...(section.fields || []).map(createLeaf),
        ],
    };
};

export const highlightMatch = (text, search) => {
    if (!search) return text;

    const lowerText = text?.toLowerCase?.();
    const lowerSearch = search?.toLowerCase?.();
    const index = lowerText?.indexOf?.(lowerSearch);

    if (index === -1) return text;

    return (
        <>
            {text?.slice?.(0, index)}
            <strong>{text?.slice?.(index, index + search?.length)}</strong>
            {text?.slice?.(index + search?.length)}
        </>
    );
};
